import React from 'react';
import styles from '../landing.module.scss';
import featureTrackingImg from '../../../assets/images/landing/feature-tracking.png';
import featureAnalyticsImg from '../../../assets/images/landing/feature-analytics.png';

const FeatureHighlight = ({ title, description, features, imageSide = 'right', variant = 'pink' }) => {
    return (
        <section className={`${styles.featureHighlightSection} ${styles[variant]}`}>
            <div className={styles.container}>
                <div className={`${styles.highlightContent} ${imageSide === 'left' ? styles.reverse : ''}`}>
                    <div className={styles.textContent}>
                        <h2>{title}</h2>
                        <p>{description}</p>
                        <ul className={styles.featureList}>
                            {features.map((feature, index) => (
                                <li key={index}>
                                    <span className={styles.checkIcon}>+</span> {feature}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={styles.imageContent}>
                        <div className={styles.blobBackground}></div>
                        <div className={styles.featureImagePlaceholder}>
                            <img
                                src={variant === 'pink' ? featureTrackingImg : featureAnalyticsImg}
                                alt={title}
                                style={{ width: '100%', borderRadius: '12px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeatureHighlight;
